import { http } from '../config';
import base from './base';

export const policy = {
  getPolicyContract() {
    return http({
      url: `${base.users}/teacherProxy/policyAndContract`,
      method: 'get'
    });
  },
  beginnerGuide(data) {
    //首次登录用户显示合同页
    return http({
      url: `${base.users}/tea/beginGuide`,
      method: 'post',
      data
    });
  },
  queryTeaNeedData(data) {
    return http({
      url: `${base.users}/tea/queryTeaNeedData`,
      method: 'post',
      data
    });
  },
  agreeTeaNeedData(data) {
    return http({
      url: `${base.users}/tea/agreeTeaNeedData`,
      method: 'post',
      data
    });
  },
  hiringAplication(data) {
    //老师招聘申请
    return http({
      url: `${base.users}/tea/hiringAplication`,
      method: 'post',
      data
    });
  },
  uploadResourceToFileSys(data) {
    //上传文件到fdfs不需要登录 --老师申请页面
    return http({
      url: `${base.async}/fileServer/uploadResourceToFileSys`,
      method: 'post',
      data
    });
  },
  uploadUnCheckFile(data) {
    //上传文件到腾讯云不需要登录 --老师申请页面
    return http({
      url: `${base.async}/fileServer/uploadUnCheckFile`,
      method: 'post',
      data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/policy.js